import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import DownloadIcon from '@mui/icons-material/Download';

const DataTable = ({ data, title, categories }) => {
  const titleStyle = {
    marginTop: '0',
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontWeight: '900',
    fontSize: '14px',
    color: '#373d3f',
  };

  const chartData = categories.categories.map((category, index) => ({
    name: category,
    data: data.map((item) => item.data[index] || '-'),
  }));

  const csvData = [
    ['Date', ...data.map((item) => item.name || 'Value')],
    ...chartData.map((item) => [item.name, ...item.data]),
  ];

  const filename = title ? `${title}.csv` : 'data.csv';

  return (
    <>
      {title && <p style={titleStyle}>{title}</p>}
      <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                {data.map((item, index) => (
                  <TableCell key={`${item.name}-${index}`}>{item.name || 'Value'}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {chartData.map((item, index) => (
                <TableRow key={`${item.name}-${index}`}>
                  <TableCell>{item.name}</TableCell>
                  {item.data.map((value, index) => (
                    <TableCell key={`${item.name}-${index}`}>{value || '-'}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
        <Button variant='outlined' color='primary' size='small' startIcon={<DownloadIcon />}>
          <CSVLink
            data={csvData}
            filename={filename}
            style={{ color: '#6366F1', textDecoration: 'none' }}
          >
            Download CSV
          </CSVLink>
        </Button>
      </div>
    </>
  );
};

DataTable.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string,
  categories: PropTypes.object.isRequired,
};

export default DataTable;
